{
    "DirectoryList_Column_Description": "Beschrijving",
    "DirectoryList_Column_TelephoneNumber": "Telefoonnummer",
    "DirectoryList_Add_Disabled_SelectTelSys": "Selecteer een telefonieserver om een ​​adresboekvermelding toe te voegen.",
    "DirectoryList_Add_Disabled_NoTelephonyFilter": "Schakel het filter 'geen telefonieserver' uit om een ​​adresboekvermelding toe te voegen.",
    "NAME": "DirectoryListLanguage"
}